const NavigationBarSpacing = () => <div className="h-16" />;

export default NavigationBarSpacing;
